import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import { CRUSH_PROFILE_TYPE } from 'type-defs'
import PictureIndicators from 'components/cards/PictureIndicators'
import Photo from 'components/cards/Photo'
import PersonInfo from 'components/profile/PersonInfo'
import ClickArea from 'components/cards/ClickArea'

export default class CrushCard extends React.PureComponent {
  static propTypes = {
    firstName: CRUSH_PROFILE_TYPE.firstName,
    pictures: CRUSH_PROFILE_TYPE.pictures,
    age: CRUSH_PROFILE_TYPE.age,
    distance: CRUSH_PROFILE_TYPE.distance,
    hideInfo: PropTypes.bool,
    hideDistance: PropTypes.bool
  }
  static defaultProps = {
    hideInfo: false,
    hideDistance: false
  }

  state = {
    activeImage: 0
  }

  handlePrevClick = () => {
    this.setPrevImage()
  }

  handleNextClick = () => {
    this.setNextImage()
  }

  setPrevImage = () => {
    const pictures = this.getPictures()

    this.setState(({ activeImage }) => ({
      activeImage: activeImage === 0 ? pictures.length - 1 : activeImage - 1
    }))
  }

  setNextImage = () => {
    const pictures = this.getPictures()

    this.setState(({ activeImage }) => ({
      activeImage: activeImage < pictures.length - 1 ? activeImage + 1 : 0
    }))
  }

  // Returns pictures without empty spaces in array.
  // The CrushCard doesn't care about the empty slots.
  getPictures = () => {
    return this.props.pictures.filter(pic => !!pic)
  }

  render() {
    const { activeImage } = this.state
    const {
      firstName,
      age,
      distance,
      hideInfo,
      hideDistance
    } = this.props

    const pictures = this.getPictures()

    return (
      <Div
        height="100%"
        width="100%"
        userSelect="none"
        position="relative"
        backgroundColor="white"
      >
        {/* Dot indicators at the top of the card */}
        {pictures.length > 1 && (
          <Div position="absolute" top={12} left={0} right={0} zIndex={2}>
            <PictureIndicators
              amount={pictures.length}
              currentIndex={activeImage}
            />
          </Div>
        )}

        {pictures.map((picture, i) => (
          <Photo key={i} src={picture.url} isVisible={i === activeImage} />
        ))}

        {/* Name, Age, Distance of a user at the bottom of the card */}
        {!hideInfo && (
          <Div position="absolute" bottom={16} left={16} zIndex={3}>
            <PersonInfo
              firstName={firstName}
              age={age}
              distance={distance}
              hideDistance={hideDistance}
              big
            />
          </Div>
        )}

        {/* Gradient at the bottom to improve PersonInfo readability */}
        {!hideInfo && (
          <Div
            position="absolute"
            zIndex={2}
            bottom={0}
            left={0}
            right={0}
            height={80}
            background="linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0))"
          />
        )}

        {/* Overlay click areas which will change the current picture */}
        {pictures.length > 1 && (
          <Div
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            zIndex={2}
            display="flex"
            flexDirection="row"
          >
            <ClickArea testId="prevImage" onClick={this.handlePrevClick} />
            <ClickArea testId="nextImage" onClick={this.handleNextClick} />
          </Div>
        )}
      </Div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/cards/CrushCard.js